import dayjs from "dayjs";
import { RefreshCw } from "lucide-react";
import { useHistory } from "react-router-dom";

import { Filter } from "../../../../components/ui/Filter";
import { Input } from "../../../../components/ui/Form/Input";
import { Select } from "../../../../components/ui/Form/Select";
import { CrmPetDiagnosisController } from "../../../../services/controllers/crmPetDiagnosis";
import { CRM_PET_DIAGNOSIS_TABS, useCrmPetDiagnosis } from "../../../../store/crmPetDiagnosis/useCrmPetDiagnosis";
import { PERIOD_OPTIONS } from "../constants";
import { PeriodButton } from "../components/PeriodButton";

export function OverviewFilter() {
  const controller = CrmPetDiagnosisController();
  const history = useHistory();
  const filters = useCrmPetDiagnosis((state) => state.data.filters.overview);
  const loading = useCrmPetDiagnosis((state) => state.data.loading);
  const isLoading = loading.overviewKpis || loading.overviewContactedKpis;

  return (
    <Filter.Root
      onSubmit={(event) =>
        controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.overview, event, history)
      }
    >
      <Filter.Container>
        <div className="flex w-full flex-wrap gap-2 pb-2">
          {PERIOD_OPTIONS.map((option) => (
            <PeriodButton
              key={option.value}
              option={option}
              active={filters.period === option.value}
              onSelect={(period) =>
                controller.setPeriod(CRM_PET_DIAGNOSIS_TABS.overview, period)
              }
              onApply={() =>
                controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.overview, null, history)
              }
            />
          ))}
        </div>
        <div className="flex w-full flex-wrap gap-3">
          <Input.Root
            pickDate
            label="Início"
            value={dayjs(filters.from).format("DD/MM/YYYY")}
            onChange={(value) =>
              controller.setDate(CRM_PET_DIAGNOSIS_TABS.overview, "from", value)
            }
          />
          <Input.Root
            pickDate
            label="Fim"
            value={dayjs(filters.to).format("DD/MM/YYYY")}
            onChange={(value) =>
              controller.setDate(CRM_PET_DIAGNOSIS_TABS.overview, "to", value)
            }
          />
          <Select.Root
            label="Ausência mínima"
            value={filters.minDays}
            style={{ minWidth: 170, maxWidth: 210 }}
            onChange={(minDays) =>
              controller.setFilter(CRM_PET_DIAGNOSIS_TABS.overview, { minDays })
            }
          >
            <Select.Option value="7">7 dias</Select.Option>
            <Select.Option value="15">15 dias</Select.Option>
            <Select.Option value="30">30 dias</Select.Option>
            <Select.Option value="45">45 dias</Select.Option>
            <Select.Option value="60">60 dias</Select.Option>
            <Select.Option value="90">90 dias</Select.Option>
          </Select.Root>
        </div>
      </Filter.Container>
      <Filter.Actions>
        <Filter.Action isLoading={isLoading}>
          <Filter.ActionIcon icon={RefreshCw} isLoading={isLoading} />
          Atualizar visão geral
        </Filter.Action>
      </Filter.Actions>
    </Filter.Root>
  );
}
